

export const onboarding = "onboarding";

export const addOnboarding = "onboarding/add";
export const editeOnboarding = "onboarding/edite";
export const deleteOnboarding = "onboarding/delete";
export const addOnboardingAdmin = "/admin/onboarding/add";
export const editeOnboardingAdmin = "/admin/onboarding/edite";
export const deleteOnboardingAdmin = "/admin/onboarding/delete";